import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import ExcelJS from "exceljs";
import isGHMC, { getCurrentDateTime1 } from "../../../Common/helper/helpar";
import { GetZone } from "../../../Apis/organizationApi";
import { TableLoader } from "../../../Common/ShimmerLoader";
import TripsAndTonnageStore from "./store/useTripsAndTonnageStore";
import MUITable from "../../../Common/MUITable";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const TripsAndTonnageReport = ({ t }) => {
    const navigate = useNavigate()
const { fetchTripsAndTonnageApi, tripsAndTonnageReportData, loading } = TripsAndTonnageStore()
    const [startDate, setStartDate] = useState(getStartOfCurrentDate());
    const [endDate, setEndDate] = useState(getCurrentDateTime());
    const [allZones, setAllZones] = useState("");
    const [zoneIds, setZoneIds] = useState([]);
    const isProd = isGHMC();

    const fetchAllZoneData = async () => {
        try {
            const zonesData = await GetZone();
            setAllZones(zonesData);
        } catch (error) {
            console.error("Error fetching initial data:", error);
        }
    };

    const tripsAndTonnageColumns = [
        {
            label: "Zone",
            field: "zoneName",
            render: (row) => row.zoneName || "N/A",
        },
        {
            label: "No.of Trips",
            field: "trips",
            render: (row) => (
                <div
                    style={{
                        cursor: "pointer",
                        color: "blue",
                    }}
                    onClick={() => navigate('/inner-tonnage-report', { state: { fromDate: startDate, toDate: endDate, zone: row.zoneId } })}
                >
                    {row.trips}
                </div>
            ),
        },
        {
            label: "Total Tonnage",
            field: "tonnage",
            render: (row) => (row.tonnage),
        },

    ];

    useEffect(() => {
        fetchAllZoneData();
        // fetchTripsAndTonnageApi(startDate, endDate, zoneId);
    }, []);

    useEffect(() => {
        const savedFilters = JSON.parse(localStorage.getItem("tripsFilter"));

        if (savedFilters) {
            setStartDate(savedFilters.startDate);
            setEndDate(savedFilters.endDate);
           setZoneIds(savedFilters.zoneIds || []);  
            fetchTripsAndTonnageApi(savedFilters.startDate, savedFilters.endDate,  (savedFilters.zoneIds || []).map(z => z.value));
        } else {
            fetchTripsAndTonnageApi(startDate, endDate, []);
        }

        fetchAllZoneData();
    }, []);

    const getSelectedZoneIds = () => zoneIds.map(z => z.value);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem("tripsFilter", JSON.stringify({
        startDate,
        endDate,
        zoneIds,
    }));
    fetchTripsAndTonnageApi(startDate, endDate, getSelectedZoneIds()); // ✅ correct call
};
    const formatDateForDisplay = (dateString) => {
        const date = new Date(dateString);
        const options = { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" };
        return date.toLocaleString("en-GB", options).replace(",", "");
    };
    // Function to format dates for display


    const options = { day: "numeric", month: "numeric", year: "numeric" };
    const generationTime = ` ${new Date().toLocaleString("en-GB", options).replace(/\//g, "/")}`;
    const downloadAsExcel = async () => {
        const currentDate = new Date();
        const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
        const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
        const cumulativeHeadingReport = `Trips And Tonnage Report ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)} - (at ${getCurrentDateTime1()})`;
        const downloadDateTime = `Report on: ${generationTime}, ${formattedTime}`;
        // const dateRange = `Date Range: ${formatDateForDisplay(startDate)} to ${formatDateForDisplay(endDate)}`;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Trips And Tonnage Report");
        const boldFont = { bold: true };

        // Add Report Generation Date
        worksheet.addRow(["", downloadDateTime, ""]);
        worksheet.mergeCells(1, 1, 1, 3);
        worksheet.getCell(1, 2).value = downloadDateTime;
        worksheet.getCell(1, 2).font = boldFont;
        worksheet.getCell(1, 2).alignment = { horizontal: "center" };

        for (let col = 2; col <= 6; col++) {
            worksheet.getCell(1, col).font = boldFont;
            worksheet.getCell(1, col).alignment = { horizontal: "center" };
        }
        for (let col = 2; col <= 12; col++) {
            worksheet.getCell(2, col).font = boldFont;
            worksheet.getCell(2, col).alignment = { horizontal: "center" };
        }

        // Add Report Title
        worksheet.addRow(["", cumulativeHeadingReport, ""]);
        worksheet.mergeCells(2, 2, 3, 6);
        worksheet.getCell(3, 2).value = cumulativeHeadingReport;
        worksheet.getCell(3, 2).font = boldFont;
        worksheet.getCell(3, 2).alignment = { horizontal: "center" };

        for (let col = 2; col <= 12; col++) {
            worksheet.getCell(3, col).font = boldFont;
            worksheet.getCell(3, col).alignment = { horizontal: "center" };
        }

        // Add empty row for spacing
        worksheet.addRow([""]);

        // Add table header row with bold font
        const tableHeaderRow = worksheet.addRow([
            "S.No",
            "Zone",
            "No.of Trips",
            "Total Tonnage",
        ]);

        tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            cell.font = boldFont;
            cell.alignment = { horizontal: "left" };
            if (colNumber >= 1 && colNumber <= 4) {
                cell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "F6B1B1" },
                };
            }
        });
        tripsAndTonnageReportData.forEach((item, index) => {
            worksheet.addRow([
                index + 1,
                item.zoneName ?? "N/A",
                // formatDateForDisplay(item.createdDate) || "N/A",
                item.trips ?? "N/A",
                item.tonnage ?? "N/A",

            ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
                if (colNumber >= 1 && colNumber <= 15) {
                    cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
                } else {
                    cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
                }
            });
        });

        // Set column widths dynamically based on content
        worksheet.columns = [
            { width: 5 },
            { width: 20 },
            { width: 20 },
            { width: 20 },


        ];

        // Save the workbook to a file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "Trips And Tonnage Report.xlsx";
        a.click();
        URL.revokeObjectURL(url);
    };

    const handleResetFilters = () => {
    const defaultStart = getStartOfCurrentDate();
    const defaultEnd = getCurrentDateTime();

    setStartDate(defaultStart);
    setEndDate(defaultEnd);
    setZoneIds([]);  
    localStorage.removeItem("tripsFilter");
    fetchTripsAndTonnageApi(defaultStart, defaultEnd, []);
};


    return (
        <>
            {loading ? (
                <TableLoader height={500} />
            ) : (
                <div style={{ width: "100%" }}>
                    <div className="content">
                        <div className="page-content">
                            <h4 className="text-start mb-3">
                                {t("Trips And Tonnage Report")} ({formatDateForDisplay(startDate)} to {formatDateForDisplay(endDate)}) (at {getCurrentDateTime1()})
                            </h4>
                            <div className="card">
                                <div className="card-body p-3">
                                    <div className="row align-items-end">
                                        <div className="col-md-12">
                                            <form onSubmit={handleFormSubmit}>
                                                <div className="row" style={{ textAlign: "left" }}>
                                                    <div className="col-md-2">
                                                        <label>From Date & Time:</label>
                                                        <input
                                                            type="datetime-local"
                                                            name="FromDate"
                                                            style={inputStyle}
                                                            value={startDate}
                                                            className="form-control"
                                                            max={endDate ? endDate : getCurrentDateTime()}
                                                            onChange={(e) => setStartDate(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label>To Date & Time:</label>
                                                        <input
                                                            type="datetime-local"
                                                            name="ToDate"
                                                            style={inputStyle}
                                                            value={endDate}
                                                            className="form-control"
                                                            min={startDate}
                                                            max={getCurrentDateTime()}
                                                            onChange={(e) => setEndDate(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="ZoneId">Zone:</label>
                                               <Select
                                                                isMulti
                                                                className="basic-multi-select"
                                                                classNamePrefix="select"
                                                                name="zoneIds"
                                                                options={allZones
                                                                    ? allZones.filter((z) => z.isActive).map((z) => ({ value: z.zoneId, label: z.zoneName }))
                                                                    : []
                                                                }
                                                                value={zoneIds}
                                                                onChange={(selected) => setZoneIds(selected || [])}
                                                                placeholder="Select Zones"
                                                                isClearable
                                                                menuPortalTarget={document.body}          
                                                                menuPosition="fixed"                       
                                                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} 
                                                            />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="d-flex justify-content-between">
                                                            <button
                                                                type="submit"
                                                                className={`btn mt-4 ${isProd ? "search-ghmc" : "search-swm"}`}
                                                            >
                                                                Search
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className={`btn mt-4 ml-2 ${isProd ? "search-ghmc" : "search-swm"}`}
                                                                onClick={handleResetFilters}
                                                            >
                                                                Reset
                                                            </button>
                                                            <button className="btn btn-excel ms-auto mt-4" onClick={downloadAsExcel}>
                                                                <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <div className="">
                                            <MUITable loading={loading}
                                                needSRNumber
                                                columns={tripsAndTonnageColumns}
                                                rows={tripsAndTonnageReportData}
                                                tableHeight={500}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

// Function to get the start of the current date (00:00 AM)
const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
};

// Function to get current date and time in the required format
const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
};

// Styles for input and button
const inputStyle = {
    border: "1px solid #E2E2E2",
    padding: "15px",
};

const buttonStyle = {
    border: "1px solid #E2E2E2",
    borderRadius: "5px",
    color: "#fff",
};

export default withTranslation()(TripsAndTonnageReport);